@if ((incomeTaxEntity$ | async) && isOndernemer) {
    <form (change)="saveForm()" [formGroup]="formGroup">
        <div class="row align-items-start">
            <div class="col-7">
                @if (isPartner) {
                    Besteedt {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
                    in {{ (incomeTaxEntity$ | async)?.year }} tenminste 1.225 uur aan de onderneming (zelfstandigenaftrek)?
                } @else {
                    <p>
                        Besteedt {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
                        in {{ (incomeTaxEntity$ | async)?.year }} tenminste 1.225 uur aan de onderneming
                        (zelfstandigenaftrek)?
                    </p>
                }
            </div>
            <div class="col-2">
                <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                  class="custom-input-150"
                                                  formControlName="krijgtZelfstandigenAftrek"
                                                  id="krijgtZelfstandigenAftrek"
                ></snelstart-ui-select-form-control>
            </div>
            <div class="col-3"></div>
        </div>

        @if (formGroup.getRawValue().krijgtZelfstandigenAftrek !== null && formGroup.getRawValue().krijgtZelfstandigenAftrek) {
            <div class="row align-items-start">
                <div class="col-7">
                    <p>
                        @if (isPartner) {
                            Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
                            in {{ (incomeTaxEntity$ | async)?.year }} recht op de starteraftrek?
                        } @else {
                            <p>
                                Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
                                in {{ (incomeTaxEntity$ | async)?.year }} recht op de starteraftrek?
                            </p>
                        }
                    </p>
                </div>
                <div class="col-2">
                    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                      class="custom-input-150"
                                                      formControlName="krijgtStartersAftrek"
                                                      id="krijgtStartersAftrek"
                    ></snelstart-ui-select-form-control>
                </div>
                <div class="col-3"></div>
            </div>
        }

        @if (formGroup.getRawValue().krijgtZelfstandigenAftrek !== null && !formGroup.getRawValue().krijgtZelfstandigenAftrek) {
            <div class="row align-items-start">
                <div class="col-7">
                    <p>
                        @if (isPartner) {
                            Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
                            in {{ (incomeTaxEntity$ | async)?.year }} recht op startersaftrek bij arbeidsongeschiktheid?
                        } @else {
                            <p>
                                Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
                                in {{ (incomeTaxEntity$ | async)?.year }} recht op startersaftrek bij
                                arbeidsongeschiktheid?
                            </p>
                        }
                    </p>
                </div>
                <div class="col-2">
                    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                      class="custom-input-150"
                                                      formControlName="krijgtStartersAftrekBijArbeidsOngeschiktheid"
                                                      id="krijgtStartersAftrekBijArbeidsOngeschiktheid"
                    ></snelstart-ui-select-form-control>
                </div>
                <div class="col-3"></div>
            </div>
        }

        @if (formGroup.getRawValue().krijgtStartersAftrekBijArbeidsOngeschiktheid) {
            <div class="row align-items-start">
                <div class="col-7">
                    <p>
                        Aantal keren startersaftrek in de jaren {{ ((incomeTaxEntity$ | async)?.year! - 6) }}
                        - {{ ((incomeTaxEntity$ | async)?.year! - 1) }}
                    </p>
                </div>
                <div class="col-2">
                    <snelstart-ui-select-form-control [options]="aantalKerenBijAO"
                                                      class="custom-input-150"
                                                      formControlName="aantalKerenStartersaftrekBijAOToegepastInAfgelopenVijfJaar"
                                                      id="aantalKerenStartersaftrekBijAOToegepastInAfgelopenVijfJaar"
                    ></snelstart-ui-select-form-control>
                </div>
                <div class="col-3"></div>
            </div>
        }

        @if (formGroup.getRawValue().krijgtZelfstandigenAftrek) {

            @if ((incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte) {
                <div class="row align-items-start">
                    <div class="col-7">
                        @if (isPartner) {
                            Werkt {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
                            mee in de onderneming?
                        } @else {
                            Werkt {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
                            mee in de onderneming?
                        }
                    </div>
                    <div class="col-2">
                        <snelstart-ui-select-form-control [options]="meewerkUren"
                                                          class="custom-input-150"
                                                          formControlName="meewerkUren"
                                                          id="meewerkUren"
                        ></snelstart-ui-select-form-control>
                    </div>
                    <div class="col-3"></div>
                </div>
            }
            <div class="row align-items-start">
                <div class="col-7">
                    @if (isPartner) {
                        Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
                        in {{ (incomeTaxEntity$ | async)?.year }} recht op aftrek voor speur- en
                                ontwikkelingswerk?
                    } @else {
                        <p>
                            Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
                            in {{ (incomeTaxEntity$ | async)?.year }} recht op aftrek voor speur- en
                            ontwikkelingswerk?
                        </p>
                    }
                </div>
                <div class="col-2">
                    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                      class="custom-input-150"
                                                      formControlName="krijgtSenOaftrek"
                                                      id="krijgtSenOaftrek"
                    ></snelstart-ui-select-form-control>
                </div>
                <div class="col-3"></div>
            </div>
            @if (formGroup.getRawValue().krijgtSenOaftrek) {
                <div class="row align-items-start">
                    <div class="col-7">
                        <p>Ook recht op de verhoogde aftrek voor speur- en ontwikkelingswerk?</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                          class="custom-input-150"
                                                          formControlName="krijgtVerhogingSenOAftrek"
                                                          id="krijgtVerhogingSenOAftrek"
                        ></snelstart-ui-select-form-control>
                    </div>
                    <div class="col-3"></div>
                </div>
                <div class="row align-items-start">
                    <div class="col-7">
                        <p>Vul het S&amp;O-nummer in:</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-text-form-control class="custom-input-150"
                                                        formControlName="speurOntwikkelaarVerklaringNummer"
                                                        id="speurOntwikkelaarVerklaringNummer"
                        ></snelstart-ui-text-form-control>
                    </div>
                    <div class="col-3"></div>
                </div>
            }
        }
        <div class="row align-items-start">
            <div class="col-7">
                @if (isPartner) {
                    Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
                    een restant zelfstandigenaftrek uit eerdere jaren? Zo ja, vul het (rest)bedrag in.
                } @else {
                    <p>
                        Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
                        een restant zelfstandigenaftrek uit eerdere jaren? Zo ja, vul het (rest)bedrag in.
                    </p>
                }
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="restantZelfstandigenaftrekUitEerdereJaren"
                                                  id="restantZelfstandigenaftrekUitEerdereJaren"
                                                  prefix="€"
                ></snelstart-ui-number-form-control>
            </div>
            <div class="col-3"></div>
        </div>

        @if (heeftWuoStaking) {
            <div class="row align-items-start">
                <div class="col-7">
                    @if (isPartner) {
                        Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
                        in {{ (incomeTaxEntity$ | async)?.year }} recht op stakingsaftrek?
                    } @else {
                        <p>
                            Besteedt {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
                            in {{ (incomeTaxEntity$ | async)?.year }} recht op stakingsaftrek?
                        </p>
                    }
                </div>
                <div class="col-2">
                    <snelstart-ui-select-form-control [options]="optionsJaNee"
                                                      class="custom-input-150"
                                                      formControlName="krijgtStakingsaftrek"
                                                      id="krijgtStakingsaftrek"
                    ></snelstart-ui-select-form-control>
                </div>
                <div class="col-3"></div>
            </div>

            @if (formGroup.getRawValue().krijgtStakingsaftrek) {
                <div class="row align-items-start">
                    <div class="col-7">
                        <p>Vul het bedrag aan eerder benutte stakingsaftrek in</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control [decimals]="0"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="bedragEerdereBenutteStakingsaftrek"
                                                          id="bedragEerdereBenutteStakingsaftrek"
                                                          prefix="€"
                        ></snelstart-ui-number-form-control>
                    </div>
                    <div class="col-3"></div>
                </div>
            }
        }
        <div class="row align-items-start">
            <div class="col-7">
                @if (isPartner) {
                    Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}
                    in {{ (incomeTaxEntity$ | async)?.year }} recht op de heffingskorting voor jonggehandicapten (wajong)?
                } @else {
                    <p>
                        Heeft {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}
                        in {{ (incomeTaxEntity$ | async)?.year }} recht op de heffingskorting voor jonggehandicapten
                        (wajong)?
                    </p>
                }
            </div>
            <div class="col-2">
                <snelstart-ui-select-form-control
                        [options]="optionsJaNee"
                        class="custom-input-150"
                        formControlName="krijgtWajong"
                        id="krijgtWajong"
                ></snelstart-ui-select-form-control>
            </div>
            <div class="col-3"></div>
        </div>
    </form>
} @else {
    <p>Er zijn geen ondernemingen gevonden.</p>
}
